import React from 'react';
import { Container } from '@michelin/acid-components';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';
import GLOBAL_CONFIG from 'global-variables';

export function HomeModule() {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return (
    <>
      <PageTitle
        eyebrow={t('Dashboard')}
        title={t(
          `Welcome back, ${permissions.location?.customer_dba_name || permissions.location?.customer_name || ''}`,
        )}
        subtitle={t('Your fleet overview.')}
      />
      <Container height="calc(100dvh - 110px)" spacing={0}>
        <iframe title="LiveTrack" src={GLOBAL_CONFIG.liveTrackUrl} style={{ border: 'none', flex: 1 }} />
      </Container>
    </>
  );
}
